module.exports = __webpack_public_path__ + "static/img/key-r.7312639a.png";